import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { Observable } from 'rxjs';
import {
  BdSharePermission,
  ShareableReference,
  ShareableType,
  ShareTarget,
  ShareTargetType,
} from '@bindoc-projects/resource-domain-lib';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';
import { ShareableGrant, ShareableGrantFull } from './grant';

@Injectable({
  providedIn: 'root',
})
export class BdGrantsService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environmentService = inject(BdAppEnvironmentService);


  public create(grant: ShareableGrant): Observable<ShareableGrantFull> {
    return this._httpClient.post<ShareableGrantFull>(this._url(), grant);
  }

  public revoke(
    shareableRef: ShareTarget,
    grantee: ShareableReference,
  ): Observable<void> {
    const body: {
      shareableReference: { id: string; type: ShareableType };
      grantee: { id: string; type: ShareTargetType };
    } = {
      shareableReference: shareableRef,
      grantee,
    };
    return this._httpClient.delete<void>(this._url(), { body });
  }

  public search(
    shareType: ShareableType,
    shareId: string,
  ): Observable<ShareableGrantFull[]> {
    return this._httpClient.get<ShareableGrantFull[]>(
      `${this._url()}${shareType}/${shareId}/`,
    );
  }

  public myGrants(
    minimumPermission: BdSharePermission = 'READ',
    companyId?: string,
  ): Observable<ShareableGrantFull[]> {
    let params = new HttpParams().set('minimumPermission', minimumPermission);
    if (companyId) {
      params = params.set('companyId', companyId);
    }
    return this._httpClient.get<ShareableGrantFull[]>(this._url(), { params });
  }

  private _url(): string {
    return `${this._environmentService.load(ApiEndpointKey.BD_PERMISSION_RESOURCE_URL)}/grants/`;
  }
}
